import React, { useContext } from "react";

import StoreLocatorContext from "@/context/StoreLocatorContext";
import { Location } from "@/custom-types/Location";
import { RetailType } from "@/custom-types/Store";

import { useFilterQueryParams } from "@/components/MenuFilters/v2/hooks";

import { StoreLocatorResultsResponse } from "../../../api/requests/consumerApi/getStoreLocatorResults";
import ShopNoResults from "../../ShopNoResults";
import DispensariesHeader from "../DispensariesHeader";
import StoreFilters from "../StoreFilters";
import StoreListings from "../StoreListings";

const StoreMenuContainer = ({
  children,
  storeLocatorResults: {
    data: { organicStores, sponsoredStores },
    metadata: { availableFilters, availableSorts, pagination, seo },
  },
  toggleFilterList,
  retailType,
  pageLocation,
  showDeliveryValidation,
  showMapButton,
  showingCBDTreatment,
  deliveryFilterSelected,
}: {
  children: React.ReactNode;
  storeLocatorResults: StoreLocatorResultsResponse;
  toggleFilterList: (open?: boolean) => void;
  retailType: RetailType;
  pageLocation: Location;
  showDeliveryValidation: boolean;
  showMapButton: boolean;
  showingCBDTreatment: boolean;
  deliveryFilterSelected: boolean;
}) => {
  const { setFiltersOpen, filtersOpen } = useContext(StoreLocatorContext);
  const {
    actions: { clearAllFilters },
  } = useFilterQueryParams();

  const stores = [...sponsoredStores, ...organicStores];

  return (
    <>
      <DispensariesHeader
        filtersOpen={filtersOpen}
        seo={seo}
        pageLocation={pageLocation}
        showDeliveryValidation={showDeliveryValidation}
      />
      <StoreFilters
        availableFilters={availableFilters}
        toggleFilterList={toggleFilterList}
        filtersOpen={filtersOpen}
        setFiltersOpen={setFiltersOpen}
        availableSorts={availableSorts}
        pagination={pagination}
        showMapButton={showMapButton}
        retailType={retailType}
      >
        {(stores.length || !showingCBDTreatment) && (
          <>
            {!stores.length && !showingCBDTreatment && (
              // TODO: update onButtonClick to reset filter state
              <ShopNoResults
                action={clearAllFilters}
                subtitleText="Try selecting fewer filter options or zoom out on the map for more results"
                primaryLinkText="clear filters"
              />
            )}
            <StoreListings
              retailType={retailType}
              sponsoredStores={sponsoredStores}
              stores={organicStores}
              deliveryFilterSelected={deliveryFilterSelected}
            />
          </>
        )}
        {children}
      </StoreFilters>
    </>
  );
};

export default StoreMenuContainer;
